import Option from "@common/components/Option/Option";
import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const Root = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 20rem;
  border-radius: 10px;
  background: none;
  border: 0.15rem solid ${vars.colors.grey80};
  margin-right: 0.4rem;
  padding-left: 0.4rem;
`;

export const NetworkRequestsIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.8rem;
  margin-left: 0.4rem;
`;

export const NetworkFilterToggle = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px 2px 8px;
  height: 2.1rem;
  margin-right: 0.4rem;

  border-radius: 10px;
  background: ${vars.colors.black};
  border: 0.15rem solid ${vars.colors.grey90};

  cursor: pointer;

  :hover {
    opacity: 0.7;
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      background: #64b1fd26;
      border: 0.15rem solid #64b1fd80;

      p {
        color: #64b1fd;
      }
    `}
`;

export const NetworkFilterToggleText = styled.p`
  font-family: Roobert, serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0;
`;

export const ErrorsCheckbox = styled(Option)`
  margin-right: 0.8rem;
  margin-left: 0.4rem;

  label {
    white-space: nowrap;
    font-family: Roobert, serif;
    font-weight: 500;
    font-size: 12px !important;
    line-height: 16px;
    letter-spacing: 0;
    color: ${vars.colors.grey60};
  }
`;
